import { useGLTF, Environment, Center } from '@react-three/drei'
import { Canvas } from '@react-three/fiber'

import React, { useRef, useState, useMemo, Suspense } from 'react'

import { OrbitControls, Stage, Plane, Sky } from '@react-three/drei'

import { useLoader, useThree } from '@react-three/fiber'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

import styles from './Configurator.module.css';

import BottomMenu from './BottomMenu';
import ARButton from './ARButton'

import {Step} from '../Step';
import ObjectWrapper from './ObjectWrapper';


const baseUrl = "https://ar-configurator-3d.herokuapp.com/";


function CameraSpy () {
    const { camera } = useThree();

    function printCamera()
    {
        console.log("Camera")
        console.dir(camera)
    }
    printCamera();

    return (<></>);

}



export default function Configurator({configuration}) {

    //const gltf = useLoader(GLTFLoader, configuration.base_url + configuration.model)
    const gltf = useGLTF(configuration.base_url + configuration.model);

    console.dir(gltf)

    //TODO deal with defaults
    // gltf.scale = configuration.scale;
    // configuration.base_camera

    var initial = configuration.variants.reduce((aggr, next) => {
        aggr[next.id] = next.options[0];
        return aggr
    }, {})

    // set an environment as default
    // initial["env"] = configuration.environments[0];

    const [instance, setInstance] = useState(initial);

    const [price, setPrice] = useState(0);

    function setEnv(env) {

        setInstance(prevState => ({
            ...prevState,
            env: env
        }))
    }

    function setColor(variant, option) {

        setInstance(prevState => {
            var value = {
                ...prevState
            };
            value[variant.id] = option;
            return value;
        })
    }

    useMemo(() => {
        
        function computePrice(instance)
        {
            // console.log("Computing price");
            // console.dir(instance);
     
             var prices = configuration.variants.map((variant) => {
     
                 var option = instance[variant.id]
                 return option != null && 'extra_price' in option ? option.extra_price : 0;
             })
             //console.dir(prices);
     
             return configuration.base_price + prices.reduce((partialSum, a) => partialSum + a, 0);;
         }

        setPrice(computePrice(instance));

    }, [instance, configuration.base_price, configuration.variants]);
    
    // Stage adjustCamera

    return (
        <div className={styles.configurator}>
            <div className="header">
                <h4 className={'title is-4 p-2 '+styles.arheader}>  </h4>
            </div>
            <div className={styles.canvasdiv}>
                <div className={styles.overlayWrapper}>
                    <Canvas camera={configuration.base_camera}>
                        <CameraSpy/>
                        <Stage shadows="contact">
                            {/*<primitive castShadow object={gltf.scene} />*/}
                            {/*<Step instance={instance}/>*/}
                            <Center bottom>
                            <ObjectWrapper gltf={gltf} instance={instance} configuration={configuration}/>
                            </Center>
                        </Stage>
                    
                        { 
                            instance.env != null ? 
                            (
                                <Suspense fallback={null}>
                                    <Environment files={baseUrl + instance.env.hdri} ground={{ 
                                      height: Math.max(12, 1), 
                                       radius: Math.max(8, (configuration.orbit.maxDistance || 100)/2)
                                    }} />
                                </Suspense>
                            )
                            : 
                            (<></>)         
                        }

                        <OrbitControls 
                            target={configuration.orbit.target || [0, -2, 0]}
                            enablePan={false}
                            minPolarAngle={configuration.orbit.minPolarAngle || 0} 
                            maxPolarAngle={configuration.orbit.maxPolarAngle || Math.PI / 2.25}
                            maxDistance={configuration.orbit.maxDistance || 24} 
                            minDistance={configuration.orbit.minDistance || 8}>
                        </OrbitControls>
                            
                    </Canvas>
                    <div className={styles.overlayButton}>
                        <ARButton configuration={configuration} setCurrentTab={null}/>
                    </div>
                </div>
            </div>
            <BottomMenu instance={instance} configuration={configuration} gltf={gltf} setEnv={setEnv} setColor={setColor} price={price}/>
        </div>
    );

}

// minAzimuthAngle={-1*Math.PI} maxAzimuthAngle={Math.PI}

// <Plane position={[0, 20, -3]} args={[4000, 40]} />